import { TutorialsSmallSvgIcon } from '@commercetools-docs/ui-kit';

export default TutorialsSmallSvgIcon;
